export const PDF_PAGE_WARNING = 10;
export const PDF_PAGE_LIMIT = 25;
export const IMAGE_DIMENSION_WARNING = 2048;
